import {useContext, useState} from "react";
import axios from "axios";
import Button from "./Button";
import Modal from "./Modal";
import {ColumnGrid, GridRow} from "./ColumnGrid";
import TextInput from "./TextInput";
import IconButton from "./IconButton";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {TemplateContext} from "../pages/MapTemplateEditor";

import config from '../config.json';

const DivisionTypeCreator = () => {
    const { template, setTemplate } = useContext(TemplateContext);
    const [ showModal, setShowModal ] = useState(false);

    const [ name, setName ] = useState();
    const [ pluralName, setPluralName ] = useState();

    const create = async () => {
        setShowModal(false);

        template.division_types.push({ name, pluralName, topLevel: true });
        setTemplate(template);
    };

    const footer = (
        <div style={{ display: "flex", gap: "20px" }}>
            <Button color="#40b319" onClick={create} content="Create"/>
            <Button color="#c20a0a" onClick={() => setShowModal(false)} content="Cancel"/>
        </div>
    );

    return (
        <>
            <Modal
                header="New Division Type"
                footer={footer}
                show={showModal}
                onClose={() => setShowModal(false)}>
                <ColumnGrid columns="1fr 1fr">
                    <GridRow>
                        <span>Name</span>
                        <TextInput onChange={e => setName(e.target.value)}/>
                    </GridRow>
                    <GridRow>
                        <span>Plural Name</span>
                        <TextInput onChange={e => setPluralName(e.target.value)}/>
                    </GridRow>
                </ColumnGrid>
            </Modal>
            <IconButton color="transparent" icon={faPlus} onClick={() => setShowModal(true)}/>
        </>
    );
}

export default DivisionTypeCreator;
